import { useLocation, Outlet } from "react-router-dom";
import Sidebar from "../Dashboard/SideBar";
import Header from "./Header";

export default function Dashboard() {
  const location = useLocation();

  // hide header if route starts with /dashboard/settings
  const hideHeader = location.pathname.startsWith("/dashboard/settings");

  return (
    <div className="min-h-screen bg-white flex">
      {/* Sidebar always visible */}
      <Sidebar />

      {/* Right Side */}
      <div className="flex-1 ml-[297px]">
        {/* Conditionally render header */}
        {!hideHeader && <Header />}

        {/* Scrollable Main Content */}
        <div
          className={`${hideHeader ? "pt-0" : "pt-[72px]"} bg-white min-h-screen px-6 py-4`}
        >
          {/* Nested routes will render here */}
          <Outlet />
        </div>
      </div>
    </div>
  );
}
